import DirectionsSVG from "@design-system/ui-icons/vanilla/Directions"
import { createIcon } from "../createIcon"

export const DirectionsIcon = createIcon(DirectionsSVG)
